import React from 'react'
import Routing from './routing/Routing'

const App = () => {
  return (
    <Routing />
  )
}

export default App